import { render, staticRenderFns } from "./sales-order-dashboard.vue?vue&type=template&id=b368407a&scoped=true&"
import script from "./js/sales-order-dashboard.js?vue&type=script&lang=js&"
export * from "./js/sales-order-dashboard.js?vue&type=script&lang=js&"
import style0 from "./sales-order-dashboard.vue?vue&type=style&index=0&id=b368407a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b368407a",
  null
  
)

export default component.exports